export const GET_MY_SUBMISSIONS = 'GET_MY_SUBMISSIONS'
export const SAVE_POINT_A = 'SAVE_POINT_A'
export const SAVE_POINT_B = 'SAVE_POINT_B'
export const SAVE_AB_FORM_CLOSURE = 'SAVE_AB_FORM_CLOSURE'
export const GET_ANALYSIS = 'GET_ANALYSIS'
export const POLL_ANALYSIS = 'POLL_ANALYSIS'
export const RESET_AB_FORM = 'RESET_AB_FORM'
export const GET_EXPECTATION_OPTIONS = 'GET_EXPECTATION_OPTIONS'
